import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export type FAQItem = {
  question: string;
  answer: string[];
};

type RaffleFAQProps = {
  items: FAQItem[];
};

const RaffleFAQ = ({ items }: RaffleFAQProps) => {
  return (
    <Box
      sx={{
        maxWidth: 900,
        mx: 'auto',
        px: { xs: 2, md: 0 },
        pt: { xs: 4, md: 7 }
      }}
    >
      {/* Header */}
      <Box sx={{ textAlign: 'center', mb: 5 }}>
        <Typography
          sx={{
            fontSize: { xs: 32, md: 40 },
            fontWeight: 900,
            color: 'black'
          }}
        >
          Frequently Asked Questions
        </Typography>
        <Typography
          sx={{
            mt: 1,
            fontSize: { xs: 15, md: 17 },
            color: 'black'
          }}
        >
          Everything you need to know about our INC Token raffle
        </Typography>
      </Box>

      {/* FAQ Items */}
      <Box sx={{ display: 'grid', gap: 2 }}>
        {items.map((item, idx) => (
          <Accordion
            key={idx}
            disableGutters
            elevation={0}
            sx={{
              borderRadius: 3,
              background: '#ffffff',
              border: '1px solid rgba(18, 31, 38, 0.10)',
              boxShadow: '0 16px 40px rgba(18, 31, 38, 0.08)',
              '&:before': { display: 'none' }
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: 'rgba(18,31,38,0.72)' }} />}
              sx={{
                px: 3,
                py: 2
              }}
            >
              <Typography
                sx={{
                  fontSize: { xs: 16, md: 18 },
                  fontWeight: 800,
                  color: '#111827'
                }}
              >
                {item.question}
              </Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ px: 3, pb: 3 }}>
              {item.answer.map((answer, index) => {
                return (
                  <Typography
                    key={index}
                    sx={{
                      fontSize: { xs: 14.5, md: 16 },
                      color: 'rgba(17,24,39,0.78)',
                      lineHeight: 1.6
                    }}
                  >
                    {answer}
                  </Typography>
                );
              })}
            </AccordionDetails>
          </Accordion>
        ))}

        <Box
          sx={{
            mt: { xs: 4, md: 5 },
            border: '1px solid black',
            borderRadius: 3,
            backdropFilter: 'blur(10px)',
            px: { xs: 2.5, md: 3.5 },
            py: { xs: 3.2, md: 3.8 },
            textAlign: 'center'
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: 18, md: 20 },
              fontWeight: 900,
              color: 'black'
            }}
          >
            Still have questions?
          </Typography>
          <Typography
            sx={{
              mt: 1,
              fontSize: { xs: 13.5, md: 14.5 },
              fontWeight: 600,
              color: 'black'
            }}
          >
            Feel free to send us an email. Or open up a support ticket on our
            Discord.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default RaffleFAQ;
